import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

export default function UploadCsvModal({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "350px",
          }}
        >
          <Box
            sx={{
              border: "1px solid rgba(93, 106, 130, 1)",
              width: "80%",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "column",
              borderRadius: "8px",
              p: 4,
            }}
          >
            <Typography variant="h5" color="rgba(35, 42, 56, 1)">
              Upload CSV
            </Typography>
            <IconButton>
              <FileUploadOutlinedIcon sx={{ height: "50px", width: "50px" }} />
            </IconButton>
            <Typography textAlign={"center"} color="rgba(93, 106, 130, 1)">
              Click or drag file to this area to upload
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
